import React from 'react';
import AffiliateList from '../components/affiliate/AffiliateList';
import { getBlackBelts, getAffiliatesByName } from '../view/HTTPService';

/**
 * /affiliatesByName - Lista com input de busca por nome.
 * Carrega faixas pretas por padrão e permite buscar por nome.
 */
export default function AffiliatesByNamePage() {
    return (
        <AffiliateList
            titleKey="msg.jkaAffiliatesByName"
            fetchAffiliates={getBlackBelts}
            searchByName={getAffiliatesByName}
        />
    );
}
